module.exports = __webpack_public_path__ + "img/MYST.ef8ed590.svg";